import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { FilterValues } from 'app/core/interfaces/filtervalues.interface';
import { ValidatorService } from 'app/core/services/validator.service';
import { FlordersFilter } from 'app/core/interfaces/florders-filter.interface';
import { FlorderFilterComponent, FlorderFilterForm } from 'app/modules/florders/florder-filter/florder-filter.component';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';
import { BreakpointObserver } from '@angular/cdk/layout';

export interface OrderFilterForm extends FlorderFilterForm {
  orderTypes: FormControl<string[]>;
  shippingCondition: FormControl<string>;
  incoterms: FormControl<string[]>;
  palletIds: FormControl<string[]>;
  packingIds: FormControl<string[]>;
  transporter: FormControl<string[]>;
  customers: FormControl<string[]>;
  ccrYes: FormControl<boolean>;
  ccrNo: FormControl<boolean>;
  sealNumber: FormControl<string>;
  orderStatuses: FormControl<string[]>;

}

@Component({
  selector: 'app-order-filter',
  templateUrl: './order-filter.component.html',
  styleUrls: ['../../florders/florder-filter/florder-filter.component.scss', './order-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush, // don't always check for changes, only when input changed (but there's no input here)
})
export class OrderFilterComponent extends FlorderFilterComponent<OrderFilterForm> implements OnInit, OnChanges {
  @Input() filterValues: FilterValues;
  @Input() customers: Customer[];
  @Output() filterOrders = new EventEmitter<{ value: FlordersFilter; valid: boolean }>();

  constructor(formBuilder: FormBuilder, validatorService: ValidatorService, breakpointObserver: BreakpointObserver, cd: ChangeDetectorRef) {
    super(formBuilder, validatorService, breakpointObserver, cd);
  }

  protected getControlsConfig() {
    const controlsConfig = super.getControlsConfig();
    Object.assign(controlsConfig, {
      orderTypes: [this.filter.orderTypes],
      shippingCondition: [this.filter.shippingCondition],
      incoterms: [this.filter.incoterms],
      palletIds: [this.filter.palletIds],
      packingIds: [this.filter.packingIds],
      transporter: [this.filter.transporter],
      customers: [this.customers ? this.filter.customers || [] : null], // null = not a transporter, no multiple customer result, [] or non-empty array: filter on (multiple) customers
      ccrYes: [this.filter.ccrYes],
      ccrNo: [this.filter.ccrNo],
      sealNumber: [this.filter.sealNumber],
      orderStatuses: [this.filter.orderStatuses],
    });
    return controlsConfig;
  }

  filterClicked(): void {
    super.filterClicked(this.filterOrders);
  }
}
